import $ from 'jquery'
import Tool from '../Tool'
import * as olSphere from 'ol/sphere'
import Control from 'ol/control/Control'
import Feature from 'ol/Feature'
import * as olCondition from 'ol/events/condition'
import FeatureSelection from '../ol/FeatureSelection'

import OL3Parser from 'jsts-ie/org/locationtech/jts/io/OL3Parser'
import UnionOp from 'jsts-ie/org/locationtech/jts/operation/union/UnionOp'
import GeometryFactory from 'jsts-ie/org/locationtech/jts/geom/GeometryFactory'
//TODO
import * as ol from 'ol'
import { getCopyStyleFunction, createInvisibleVectorLayer } from '../ol'

import {
  Point,
  LineString,
  Polygon,
  MultiPoint,
  MultiLineString,
  MultiPolygon,
  LinearRing,
  GeometryCollection
} from 'ol/geom'
import drawLayer from '../drawLayer'

var sphereOptions = {
  projection: 'EPSG:4326',
  radius: 6378137
}

/**
 * Copy tool
 *
 * @param {Object} config
 * @constructor
 */
export default class Copy extends Tool {
  constructor(config) {
    super()

    $.extend(this, config)

    this.$popover = $(`<div class="popover top in copy-tool-modal" style="margin:0">
                        <div class="popover-header">
                          <h3 class="popover-title">Kopiera</h3>
                          <a class="close popover-close"></a>
                        </div>
                        <div class="popover-content">

                        </div>
                        <div class="popover-footer">
                            <div class="btn-toolbar"></div>
                        </div>
                      </div>`)

    this.$popover.css({
      width: 180,
      'min-width': 'initial',
      'max-width': 'initial',
      'margin-top': 5,
      left: 'calc(50% - 90px)',
      position: 'absolute',
      top: 67,
      'z-index': 10
    })

    this.$label = $(`<div></div>`)
    this.$label.appendTo(this.$popover.find('.popover-content:first'))
    this.$area = $(`<div></div>`)
    this.$area.appendTo(this.$popover.find('.popover-content:first'))

    this.$cancelButton = $(
      `<button type="button" class="btn btn-default btn-sm">Avbryt</button>`
    )
    this.$cancelButton.css({
      display: 'initial',
      'margin-bottom': 10
    })
    this.$cancelButton.appendTo(this.$popover.find('.btn-toolbar:first'))
    this.$cancelButton.on(
      'click',
      this.api.toolbar.deactivateTool.bind(this.api.toolbar)
    )

    this.$confirmButton = $(
      `<button type="button" class="btn btn-primary btn-sm">Skapa yta</button>`
    )
    this.$confirmButton.appendTo(this.$popover.find('.btn-toolbar:first'))
    this.$confirmButton.on('click', this.handleConfirmButtonClick.bind(this))

    this.geometryFactory = new GeometryFactory()
    this.parser = new OL3Parser(this.geometryFactory, ol)
    this.parser.inject(
      Point,
      LineString,
      LinearRing,
      Polygon,
      MultiPoint,
      MultiLineString,
      MultiPolygon,
      GeometryCollection
    )

    this.control = new Control({
      element: this.$popover.get(0)
    })

    this.ui.iconClass = 'fa fa-copy'

    this.layers = []
    this.drawSource = drawLayer.getSource()
    this.map.on('click', this.handleClick.bind(this))
    this.featureSelection = new FeatureSelection({
      map: this.map,
      style: getCopyStyleFunction()
    })
    this.drawEndApiTrigger = this.api.draw.createTrigger()
    this.updateLabel()
  }

  activate() {
    this.layers = this.map
      .getLayers()
      .getArray()
      .filter(
        l =>
          l.get('olga_') &&
          l.get('olga_').metadata &&
          l.get('olga_').metadata.copy
      )
      .map(l => {
        const config = l.get('olga_')

        const layer = createInvisibleVectorLayer(config)

        layer.set('copyLayer_', true)
        layer.set('originalRef_', l)
        return layer
      })
    this.layers.forEach(this.map.addLayer.bind(this.map))
    this.map.addControl(this.control)
    this.updateLabel()
    super.activate()
    this.featureSelection.activate()
  }

  deactivate() {
    this.layers.forEach(this.map.removeLayer.bind(this.map))
    this.layers = []
    this.featureSelection.getFeatures().clear()
    this.map.removeControl(this.control)
    super.deactivate()
    this.featureSelection.deactivate()
  }

  handleConfirmButtonClick() {
    const features = this.featureSelection.getFeatures().getArray()
    if (features.length < 1) {
      return
    }

    const result = features
      .map(f => this.parser.read(f.getGeometry()))
      .reduce(UnionOp.union, this.geometryFactory.createGeometryCollection())

    const unionFeature = new Feature()
    unionFeature.setGeometry(this.parser.write(result))
    this.drawSource.addFeature(unionFeature)
    this.drawEndApiTrigger({
      type: 'drawend',
      feature: unionFeature
    })
    this.api.toolbar.deactivateTool()
  }

  handleClick(e) {
    if (!this.activated) {
      return
    }

    const features = this.map.getFeaturesAtPixel(e.pixel, {
      hitTolerance: 5,
      layerFilter: l =>
        l.get('copyLayer_') && l.get('originalRef_').getVisible()
    })
    const selectedFeature = features && features[0]
    if (!selectedFeature) {
      return
    }
    const alreadySelectedFeatures = this.featureSelection.getFeatures()
    if (!alreadySelectedFeatures.remove(selectedFeature)) {
      alreadySelectedFeatures.push(selectedFeature)
    }
    this.updateLabel()
  }

  getArea(geom) {
    if (geom instanceof Polygon) {
      var area
      var sourceProj = this.map.getView().getProjection()
      var geom = geom.clone().transform(sourceProj, 'EPSG:4326')
      //var coordinates = geom.getLinearRing(0).getCoordinates()
      area = Math.abs(olSphere.getArea(geom, sphereOptions))

      var hektar = Math.round((area / 10000) * 10) / 10

      return hektar
    } else if (geom instanceof MultiPolygon) {
      return geom.getPolygons().reduce((r, g) => r + this.getArea(g), 0)
    } else {
      return 0
    }
  }

  updateLabel() {
    const selectedFeatures = this.featureSelection.getFeatures().getArray()
    const area = selectedFeatures
      .map(f => f.getGeometry())
      .map(f => this.getArea(f))
      .reduce((r, a) => r + a, 0)
    const numberMarked = selectedFeatures.length
    this.$label.text(`${numberMarked} markerad${numberMarked > 1 ? 'e' : ''}`)
    this.$area.text(`${area.toFixed(1)}ha`)
  }
}
